import React, { useState } from 'react';
import { TextInput, Platform, Modal, ScrollView } from 'react-native';
import { SText, STheme, SView } from 'servisofts-component2';

export default function Iten_check({ type = 'check', label, cancelActive, confirmActive, onCancel, onConfirm, value, onChangeText, onFocus, onBlur, onEndEditing, options = [], selectedValue, onSelectChange }) {
    const [showDropdown, setShowDropdown] = useState(false);
    const selectOptions = Array.isArray(options) && options.length > 0 ? options : [];

    const getOptionLabel = (opt) => {
        if (!opt) return '';
        if (typeof opt === 'string') return opt;
        return String(opt?.label ?? opt?.nombre ?? opt?.text ?? opt?.value ?? '');
    };

    const getOptionValue = (opt) => {
        if (!opt) return '';
        if (typeof opt === 'string') return opt;
        return String(opt?.value ?? opt?.id ?? opt?.label ?? opt?.nombre ?? opt?.text ?? '');
    };

    const selectedLabel = getOptionLabel(selectOptions.find(opt => getOptionValue(opt) === selectedValue)) || 'Select';
    return (
        <SView col={"xs-12"} row style={{ alignItems: 'center', justifyContent: 'space-between', paddingVertical: 2 }} >
            <SView flex>
                <SText font='AlbertSans' fontSize={15} color={STheme.color.text}>{label}</SText>
            </SView>
            <SView width={75} row center style={{ justifyContent: 'space-between' }} >

                {type === 'number' ? (
                    <TextInput
                        placeholder='0.00'
                        placeholderTextColor={"rgba(202, 202, 202, 0.55)"}
                        keyboardType='decimal-pad'
                        inputMode='decimal'
                        autoCapitalize='none'
                        autoCorrect={false}
                        multiline={false}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        onEndEditing={onEndEditing}
                        value={value ? String(value) : ''}
                        onChangeText={(text) => {
                            const normalized = String(text).replace(',', '.');
                            const numericOnly = normalized.replace(/[^0-9.]/g, '');
                            const parts = numericOnly.split('.');
                            const integerPart = (parts[0] ?? '').slice(0, 5);
                            const decimalPart = parts.slice(1).join('').slice(0, 2);
                            const safeValue = parts.length > 1
                                ? `${integerPart || '0'}.${decimalPart}`
                                : integerPart;
                            onChangeText?.(safeValue);
                        }}
                        style={{
                            width: '100%', minHeight: 30,
                            borderRadius: 4, borderWidth: 1.5, borderColor: STheme.color.lightGray,
                            backgroundColor: STheme.color.card, color: STheme.color.text, padding: 3, fontSize: 14, textAlignVertical: 'top', outlineWidth: 0, outlineStyle: "none",
                        }} />
                ) : type === 'select' ? (
                    Platform.OS === 'web' ? (
                        <select
                            value={selectedValue ?? ''}
                            onChange={(e) => {
                                onSelectChange?.(e.target.value);
                            }}
                            style={{
                                width: '100%',
                                minHeight: 30,
                                borderRadius: 4,
                                borderWidth: 1.5,
                                borderColor: STheme.color.lightGray,
                                backgroundColor: STheme.color.primary,
                                color: STheme.color.text,
                                padding: 3,
                                fontSize: 14,
                                border: `1.5px solid ${STheme.color.lightGray}`,
                                outline: 'none',
                            }}>
                            <option value="">Select</option>
                            {(selectOptions || []).map((opt, idx) => {
                                try {
                                    if (!opt) return null;
                                    if (typeof opt === 'string') {
                                        return <option key={`${idx}`} value={opt}>{opt}</option>;
                                    }
                                    const label = String(opt?.label ?? opt?.nombre ?? opt?.text ?? opt?.value ?? '');
                                    const val = String(opt?.value ?? opt?.id ?? label ?? '');
                                    if (!label || !val) return null;
                                    return <option key={`${idx}`} value={val}>{label}</option>;
                                } catch (e) {
                                    console.error('Error rendering select option:', e);
                                    return null;
                                }
                            })}
                        </select>
                    ) : (
                        <>
                            <SView
                                onPress={() => setShowDropdown(true)}
                                style={{
                                    width: '100%', minHeight: 30,
                                    borderRadius: 4, borderWidth: 1.5, borderColor: STheme.color.lightGray,
                                    backgroundColor: STheme.color.card,
                                    color: STheme.color.text,
                                    paddingHorizontal: 8,
                                    justifyContent: 'center',
                                }}
                            >
                                <SText style={{ fontSize: 14, color: selectedValue ? STheme.color.text : STheme.color.lightGray }}> {selectedLabel} </SText>
                            </SView>
                            <Modal visible={showDropdown} transparent={true} animationType="fade" >
                                <SView style={{ flex: 1, backgroundColor: 'rgba(0,0,0,0.5)', justifyContent: 'center', alignItems: 'center' }}>
                                    <SView style={{
                                        backgroundColor: STheme.color.background,
                                        borderRadius: 12, width: '85%', maxHeight: '70%'
                                    }}>
                                        <SView style={{ paddingHorizontal: 16, paddingVertical: 12, borderBottomWidth: 1, borderBottomColor: STheme.color.grayLight2 }}>
                                            <SText style={{ fontSize: 16, fontWeight: 'bold', color: STheme.color.text }}>{label}</SText>
                                        </SView>
                                        <ScrollView style={{ maxHeight: '100%' }}>
                                            {(selectOptions || []).map((opt, idx) => {
                                                try {
                                                    if (!opt) return null;
                                                    const optLabel = getOptionLabel(opt);
                                                    const optValue = getOptionValue(opt);
                                                    if (!optLabel || !optValue) return null;
                                                    const isSelected = optValue === selectedValue;
                                                    return (
                                                        <SView
                                                            key={`${idx}`}
                                                            onPress={() => {
                                                                onSelectChange?.(optValue);
                                                                setShowDropdown(false);
                                                            }}
                                                            style={{
                                                                paddingHorizontal: 16,
                                                                paddingVertical: 12,
                                                                borderBottomWidth: 1,
                                                                borderBottomColor: STheme.color.grayLight2,
                                                                backgroundColor: isSelected ? STheme.color.lightGray : STheme.color.card,
                                                            }}
                                                        >
                                                            <SText style={{ fontSize: 14, color: isSelected ? STheme.color.primary : STheme.color.text }}> {optLabel} </SText>
                                                        </SView>
                                                    );
                                                } catch (e) {
                                                    console.error('Error rendering dropdown item:', e);
                                                    return null;
                                                }
                                            })}
                                        </ScrollView>
                                        <SView style={{ paddingHorizontal: 16, paddingVertical: 12, borderTopWidth: 1, borderTopColor: STheme.color.grayLight2 }}>
                                            <SView
                                                onPress={() => setShowDropdown(false)}
                                                style={{ backgroundColor: STheme.color.grayLight2, paddingHorizontal: 12, paddingVertical: 10, borderRadius: 8, alignItems: 'center', }} >
                                                <SText style={{ fontSize: 14, fontWeight: 'bold', color: STheme.color.text }}>Cerrar</SText>
                                            </SView>
                                        </SView>
                                    </SView>
                                </SView>
                            </Modal>
                        </>
                    )
                ) : (
                    <>
                        <SView
                            width={30} height={30} center
                            style={{
                                borderRadius: 6,
                                borderWidth: 2,
                                borderColor: STheme.color.danger,
                                backgroundColor: cancelActive ? STheme.color.danger : 'transparent',
                            }}
                            onPress={onCancel} >
                            {cancelActive ? <SText font='AlbertSans' bold fontSize={16} color={STheme.color.white}>✕</SText> : null}
                        </SView>
                        <SView
                            width={30} height={30} center
                            style={{
                                borderRadius: 6,
                                borderWidth: 2,
                                borderColor: STheme.color.secondary,
                                backgroundColor: confirmActive ? STheme.color.secondary : 'transparent',
                                marginLeft: 8,
                            }}
                            onPress={onConfirm} >
                            {confirmActive ? <SText font='AlbertSans' bold fontSize={16} color={STheme.color.background}>✓</SText> : null}
                        </SView>
                    </>
                )}
            </SView>
        </SView>
    );
}